export default __webpack_public_path__ + "static/media/Permit_Decision_Tree.45749ca2.pdf";